import React, { useEffect, useState } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
    termsPageRequest,
    loyaltyAgreementDocSelector,
} from '@ibibo/myaccount-reducer';


const terminationPoints = [
    '“Affiliates” includes persons which are Controlled by Company, or under common Control of a person who is controlling Company.',
    '“Booking” means the booking of the Platform Service, through the Company Platform, between the Service Provider and customer.',
    '“Booking Voucher” means voucher generated subsequent to the confirming of the Booking which gives the break-up of the listing price of the Platform Services, any applicable taxes along with the details of the customer and the name of the Travel Agent partner.',
    '“Company Group” means any entity whiconst loyaltyAgreementDoc = useSelector(loyaltyAgreementDocSelector);ch is controlled by, or controls, or under common control as the Company.',
    '“Company Platform” means any present or future booking or information platforms (like websites, mobile applications, m-sites, processes and sales channels) owned or operated by any entity forming part of the Company Group. Company Platforms include the www.mypartner.makemytrip.com, www.makemytrip.com and their respective mobile applications.',
    '“Control” means ability to, directly or indirectly, direct or cause the direction of the management or policies of a person, whether through the ownership of voting securities, by contract or otherwise.',
    '"Intellectual Property Right" means any patent, copyright, inventions, database rights, design right, registered design, trade mark, trade name, brand, logos, service mark, know-how, utility model'
]

const navigationSec = {
    backBtn: true,
    expiryInfo: "SESSION EXPIRES IN : <span class='latoBlack'>09m 54s</span>",
    stepTrack: "STEP <span class='blackText'>3 OF 3</span>",
    step: "3",
}

const TerminationPage = () => {

    const winSize = window.screen.width;
    const dispatch = useDispatch();
    const loyaltyAgreementDoc = useSelector(loyaltyAgreementDocSelector);

    useEffect(()=>{
        getTerminationContract();
    },[])

    const getTerminationContract = () => {
        dispatch(termsPageRequest('', successCallback, errorCallback));
    }

    const successCallback = (data) => {

    }

    const errorCallback = () => {
    }

    return (
        loyaltyAgreementDoc?.loyaltyAgreementDate?.data ?  <div className='subHeading' dangerouslySetInnerHTML={{ __html: loyaltyAgreementDoc?.loyaltyAgreementDate?.data }}></div> : <></>
    )
}

export default TerminationPage;
